import { t } from "@lingui/macro";
import * as v from "valibot";
import type { Permission } from "~/models/permission";
import { Step } from "./ViewBody";

export const key = "media.upload";

export const permissions: Array<Permission | RegExp> = ["Media.Upload"];

export const Schema = () =>
  v.object({
    artistUid: v.pipe(
      v.string(t`The artist ID is required.`),
      v.minLength(1, t`The artist ID is required.`),
    ),
    labelUid: v.pipe(
      v.string(t`The label ID is required.`),
      v.minLength(1, t`The label ID is required.`),
    ),
    redirectTo: v.optional(v.string(t`The redirect URL must be a string.`)),
    step: v.optional(v.enum(Step)),
  });
